import { isApiErrorDto } from "../../../errors/isApiErrorDto";

const ALREADY_DECIDED = ["zz_ContractApiErrorCode_OptionLocked", "zz_ContractApiErrorCode_OptionAlreadyExecuted"];

export const isRefusedAsAlreadyDecided = (error: unknown): boolean => {
  const body = (error as { data?: unknown } | null | undefined)?.data;
  return isApiErrorDto(body) && ALREADY_DECIDED.includes(body.errorCode);
};
